/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailStorageStatsInbox
 */
export interface EmailStorageStatsInbox {
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsInbox
     */
    totalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsInbox
     */
    unreadItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsInbox
     */
    sizeInBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailStorageStatsInbox
     */
    sizeMB?: string;
}

/**
 * Check if a given object implements the EmailStorageStatsInbox interface.
 */
export function instanceOfEmailStorageStatsInbox(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailStorageStatsInboxFromJSON(json: any): EmailStorageStatsInbox {
    return EmailStorageStatsInboxFromJSONTyped(json, false);
}

export function EmailStorageStatsInboxFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailStorageStatsInbox {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalItemCount': !exists(json, 'totalItemCount') ? undefined : json['totalItemCount'],
        'unreadItemCount': !exists(json, 'unreadItemCount') ? undefined : json['unreadItemCount'],
        'sizeInBytes': !exists(json, 'sizeInBytes') ? undefined : json['sizeInBytes'],
        'sizeMB': !exists(json, 'sizeMB') ? undefined : json['sizeMB'],
    };
}

export function EmailStorageStatsInboxToJSON(value?: EmailStorageStatsInbox | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalItemCount': value.totalItemCount,
        'unreadItemCount': value.unreadItemCount,
        'sizeInBytes': value.sizeInBytes,
        'sizeMB': value.sizeMB,
    };
}

